import { render, staticRenderFns } from "./ListTabelaPrecoItem.vue?vue&type=template&id=1b5737ce&scoped=true&"
import script from "./ListTabelaPrecoItem.vue?vue&type=script&lang=js&"
export * from "./ListTabelaPrecoItem.vue?vue&type=script&lang=js&"
import style0 from "./ListTabelaPrecoItem.vue?vue&type=style&index=0&id=1b5737ce&prod&lang=scss&scoped=true&"
import style1 from "./ListTabelaPrecoItem.vue?vue&type=style&index=1&id=1b5737ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5737ce",
  null
  
)

export default component.exports